

































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

type IMessageType = 'info' | 'success' | 'warning' | 'error';

@Component
export default class SMessage extends Vue {
  @Prop(Function) public onClose!: (id: number) => void;
  @Prop({ type: String, default: 'info' }) public type?: IMessageType;
  @Prop({ default: 3000, type: Number }) public duration!: number;
  @Prop(String) public message!: string;
  @Prop(String) public title?: string;
  @Prop(Number) public id!: number;
  public open = true;
  public timer: NodeJS.Timeout | 0 = 0;

  public created() {
    if (this.duration > 0) {
      this.timer = setTimeout(() => {
        this.closeMessage();
      }, this.duration);
    } else {
      this.timer = 0;
    }
  }

  public get getTitle() {
    return this.title || this.message;
  }

  @Emit('onClose')
  public closeMessage() {
    this.open = false;
    if (this.timer) clearTimeout(this.timer);
    return this.open;
  }
}
